var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", dense: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Create Downtime Report")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "white",
                    small: "",
                    text: "",
                    to: "/downtime-reports"
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-arrow-left")
                  ]),
                  _vm._v(" Back ")
                ],
                1
              )
            ],
            1
          ),
          _c("v-card-text", [
            _c(
              "form",
              { ref: "mainFormRef" },
              [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-switch", {
                          attrs: {
                            inset: "",
                            color: "primary",
                            label: "Service Report"
                          },
                          model: {
                            value: _vm.isServiceReport,
                            callback: function($$v) {
                              _vm.isServiceReport = $$v
                            },
                            expression: "isServiceReport"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Customer",
                            name: "customer_id",
                            "item-value": "id",
                            "item-text": item => `${item.id} - ${item.name}`,
                            items: _vm.customers,
                            "error-messages": _vm.errors.customer_id
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Unit",
                            name: "unit_id",
                            "error-messages": _vm.errors.unit_id
                          }
                        })
                      ],
                      1
                    ),
                    _vm.isServiceReport
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", md: "6" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                "hide-details": "auto",
                                dense: "",
                                label: "Subject",
                                name: "subject",
                                value: _vm.subject,
                                "error-messages": _vm.errors.subject
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-select", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Machine Type",
                            name: "machine_type_id",
                            items: _vm.machineTypes,
                            "item-value": "id",
                            "item-text": "name",
                            "error-messages": _vm.errors.machine_type_id
                          },
                          model: {
                            value: _vm.machineTypeId,
                            callback: function($$v) {
                              _vm.machineTypeId = $$v
                            },
                            expression: "machineTypeId"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Reported At",
                            name: "reported_at",
                            type: "datetime-local",
                            value: _vm.reportedAt,
                            "error-messages": _vm.errors.reported_at
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Date Start",
                            name: "date_start",
                            type: "datetime-local",
                            value: _vm.dateStart,
                            "error-messages": _vm.errors.date_start
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Date End",
                            name: "date_end",
                            type: "datetime-local",
                            "error-messages": _vm.errors.date_end
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-select", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Status Before",
                            name: "list_status_before",
                            items: ["operational", "non-operational"],
                            "error-messages": _vm.errors.list_status_before
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-select", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Status After",
                            name: "list_status_after",
                            items: ["operational", "non-operational"],
                            "error-messages": _vm.errors.list_status_after
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.isServiceReport
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", md: "6" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                label: "Reported Issue",
                                name: "reported_issue",
                                "error-messages": _vm.errors.reported_issue
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isServiceReport
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("v-textarea", {
                              attrs: {
                                outlined: "",
                                "hide-details": "auto",
                                dense: "",
                                rows: "3",
                                "auto-grow": "",
                                label: "Description",
                                name: "description",
                                value: _vm.description,
                                "error-messages": _vm.errors.description
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isServiceReport
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", md: "6" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                label: "Error Code",
                                name: "error",
                                "error-messages": _vm.errors.error
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("v-divider", { staticClass: "my-4" }),
                _c(
                  "h4",
                  { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                  [_vm._v("Inspection Findings")]
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _vm._l(_vm.inspectionFindings, function(finding, i) {
                      return _c(
                        "v-col",
                        { key: "finding-" + i, attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              label: `Finding ${i + 1}`,
                              "append-icon": "mdi-delete"
                            },
                            on: {
                              "click:append": function($event) {
                                return _vm.inspectionFindings.splice(i, 1)
                              }
                            },
                            model: {
                              value: _vm.inspectionFindings[i],
                              callback: function($$v) {
                                _vm.$set(_vm.inspectionFindings, i, $$v)
                              },
                              expression: "inspectionFindings[i]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", color: "green" },
                            on: {
                              click: function($event) {
                                return _vm.inspectionFindings.push("")
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "", small: "" } }, [
                              _vm._v("mdi-plus")
                            ]),
                            _vm._v("Add Finding ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c("v-divider", { staticClass: "my-4" }),
                _c(
                  "h4",
                  { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                  [_vm._v("Actions")]
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _vm._l(_vm.actions, function(action, i) {
                      return _c(
                        "v-col",
                        { key: "action-" + i, attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              label: `Action ${i + 1}`,
                              "append-icon": "mdi-delete",
                              "error-messages":
                                _vm.errors[`actions.${i}.action`]
                            },
                            on: {
                              "click:append": function($event) {
                                return _vm.removeAction(i)
                              }
                            },
                            model: {
                              value: _vm.actions[i],
                              callback: function($$v) {
                                _vm.$set(_vm.actions, i, $$v)
                              },
                              expression: "actions[i]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", color: "green" },
                            on: {
                              click: function($event) {
                                return _vm.actions.push("")
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "", small: "" } }, [
                              _vm._v("mdi-plus")
                            ]),
                            _vm._v("Add Action ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c("v-divider", { staticClass: "my-4" }),
                _c(
                  "h4",
                  { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                  [_vm._v("Recommendations")]
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _vm._l(_vm.recommendations, function(rec, i) {
                      return _c(
                        "v-col",
                        { key: "rec-" + i, attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              label: `Recommendation ${i + 1}`,
                              "append-icon": "mdi-delete"
                            },
                            on: {
                              "click:append": function($event) {
                                return _vm.recommendations.splice(i, 1)
                              }
                            },
                            model: {
                              value: _vm.recommendations[i],
                              callback: function($$v) {
                                _vm.$set(_vm.recommendations, i, $$v)
                              },
                              expression: "recommendations[i]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", color: "green" },
                            on: {
                              click: function($event) {
                                return _vm.recommendations.push("")
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "", small: "" } }, [
                              _vm._v("mdi-plus")
                            ]),
                            _vm._v("Add Recommendation ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c("v-divider", { staticClass: "my-4" }),
                _c("v-switch", {
                  attrs: {
                    inset: "",
                    label: "Purchase Needed",
                    "true-value": true,
                    "false-value": false
                  },
                  model: {
                    value: _vm.purchaseNeeded,
                    callback: function($$v) {
                      _vm.purchaseNeeded = $$v
                    },
                    expression: "purchaseNeeded"
                  }
                }),
                _c("v-divider", { staticClass: "my-4" }),
                _c(
                  "h4",
                  { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                  [_vm._v("Images")]
                ),
                _vm._l(_vm.imageRows, function(row, rowIndex) {
                  return _c(
                    "v-row",
                    {
                      key: "row-" + rowIndex,
                      attrs: { dense: "", align: "center" }
                    },
                    _vm._l(row, function(img, i) {
                      return _c(
                        "v-col",
                        {
                          key: "img-" + rowIndex + "-" + i,
                          attrs: {
                            cols: 12,
                            sm: Math.floor(_vm.spanToNumber(img.span) * 12)
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-column",
                              staticStyle: { gap: "10px" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  label: "Image Name",
                                  "error-messages":
                                    _vm.errors[
                                      `images.${_vm.getImageIndex(img)}.name`
                                    ]
                                },
                                model: {
                                  value: img.name,
                                  callback: function($$v) {
                                    _vm.$set(img, "name", $$v)
                                  },
                                  expression: "img.name"
                                }
                              }),
                              _c("v-file-input", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  accept: "image/*",
                                  "prepend-inner-icon": "mdi-image",
                                  "append-icon": "",
                                  label: "Image",
                                  "error-messages":
                                    _vm.errors[
                                      `images.${_vm.getImageIndex(img)}.file`
                                    ]
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onFileChange($event, img)
                                  }
                                }
                              }),
                              _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  label: "Span",
                                  items: _vm.spanOptions,
                                  "item-text": "label",
                                  "item-value": "value",
                                  "error-messages":
                                    _vm.errors[
                                      `images.${_vm.getImageIndex(img)}.span`
                                    ]
                                },
                                model: {
                                  value: img.span,
                                  callback: function($$v) {
                                    _vm.$set(img, "span", $$v)
                                  },
                                  expression: "img.span"
                                }
                              })
                            ],
                            1
                          ),
                          img.preview
                            ? _c("v-img", {
                                staticClass: "mt-2 rounded",
                                attrs: {
                                  src: img.preview,
                                  "max-height": "220",
                                  contain: ""
                                }
                              })
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1",
                              attrs: { icon: "", small: "", color: "red" },
                              on: {
                                click: function($event) {
                                  return _vm.removeImage(img)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-close")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                }),
                _c(
                  "v-btn",
                  {
                    staticClass: "mt-2",
                    attrs: { small: "", color: "blue darken-1", dark: "" },
                    on: { click: _vm.addImage }
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
                    _vm._v(" Add Image ")
                  ],
                  1
                ),
                _c("v-divider", { staticClass: "my-4" }),
                _c(
                  "h4",
                  { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                  [_vm._v("Prepared By")]
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Prepared By",
                            items: _vm.preparedByDropdown,
                            "error-messages": _vm.errors.prepared_by,
                            "search-input": _vm.preparedBySearch,
                            "no-filter": "",
                            "return-object": "",
                            "item-value": "prepared_by"
                          },
                          on: {
                            "update:searchInput": function($event) {
                              _vm.preparedBySearch = $event
                            },
                            "update:search-input": function($event) {
                              _vm.preparedBySearch = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function({ item }) {
                                return [_vm._v(_vm._s(item.prepared_by))]
                              }
                            },
                            {
                              key: "item",
                              fn: function({ item }) {
                                return [
                                  _vm._v(_vm._s(item.prepared_by) + " - "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(item.prepared_by_position || "N/A")
                                    )
                                  ])
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.preparedByObject,
                            callback: function($$v) {
                              _vm.preparedByObject = $$v
                            },
                            expression: "preparedByObject"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            label: "Position",
                            "error-messages": _vm.errors.prepared_by_position,
                            items: _vm.preparedByPositions
                          },
                          model: {
                            value: _vm.preparedByPosition,
                            callback: function($$v) {
                              _vm.preparedByPosition = $$v
                            },
                            expression: "preparedByPosition"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "mt-3", attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { block: "", disabled: !_vm.purchaseNeeded },
                            on: {
                              click: function($event) {
                                _vm.components.open = true
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("mdi-cog")
                            ]),
                            _vm._v(" Components ")
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { block: "", color: "primary", dark: "" },
                            on: { click: _vm.store }
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("mdi-check")
                            ]),
                            _vm._v(" Submit ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            )
          ])
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: "" },
          model: {
            value: _vm.components.open,
            callback: function($$v) {
              _vm.$set(_vm.components, "open", $$v)
            },
            expression: "components.open"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Components")]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.components.data, function(component, i) {
                      return _c(
                        "v-col",
                        { key: i, attrs: { cols: "12" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              label: `Component ${i + 1}`,
                              "item-value": "id",
                              "item-text": item =>
                                `(${item.typeName} - ${item.categoryName}) ${item.name}`,
                              items: _vm.filteredMachineComponents,
                              "error-messages":
                                _vm.errors[
                                  `machine_components.${i}.machine_component_id`
                                ],
                              "append-icon": "mdi-delete"
                            },
                            on: {
                              "click:append": function($event) {
                                return _vm.removeComponent(i)
                              }
                            },
                            model: {
                              value: _vm.components.data[i],
                              callback: function($$v) {
                                _vm.$set(_vm.components.data, i, $$v)
                              },
                              expression: "components.data[i]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-space-between mt-2" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", color: "green" },
                          on: {
                            click: function($event) {
                              return _vm.components.data.push(null)
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-plus")
                          ]),
                          _vm._v("Add ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", color: "red" },
                          on: {
                            click: function($event) {
                              _vm.components.open = false
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-close")
                          ]),
                          _vm._v("Close ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }